var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height pa-16",
    attrs: {
      "value": _vm.thisTab
    }
  }, [_c('v-layout', {
    staticClass: "h-100 mx-auto",
    staticStyle: {
      "max-width": "1224px"
    },
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "320px",
      "min-height": "240px",
      "overflow": "hidden"
    },
    attrs: {
      "flat": "",
      "rounded": "xl"
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('qrcode-stream-reader', _vm._g(_vm._b({
    model: {
      value: _vm.decoded,
      callback: function ($$v) {
        _vm.decoded = $$v;
      },
      expression: "decoded"
    }
  }, 'qrcode-stream-reader', {
    propCamera: _vm.propCamera
  }, false), {
    input: _vm.onDecoded,
    changeCamera: function (camera) {
      return _vm.propCamera = camera;
    }
  }), [_c('message-snackbar', _vm._b({
    attrs: {
      "absolute": "",
      "bottom": "",
      "tile": ""
    },
    on: {
      "close": function ($event) {
        _vm.message = null;
      }
    }
  }, 'message-snackbar', {
    message: _vm.message
  }, false))], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "v-btn-group flex-wrap mt-16"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, 'v-btn', {
    disabled: _vm.disabled,
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 다음 단계 ")]), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }